import createModel, { prop } from './lib/create_model';

export const RecommendedAnswerCount = createModel({
  modelName: 'RecommendedAnswerCount',
  properties: {
    id: prop(String).isRequired,
    count: prop(Number).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const RecommendedAnswersCounts = createModel({
  modelName: 'RecommendedAnswersCounts',
  properties: {
    counts: prop([RecommendedAnswerCount]).default([]),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default RecommendedAnswersCounts;
